import gql from 'graphql-tag';

export const DeleteIncidentIssue = gql`
  mutation DeleteIncidentIssueBulk($input: DeleteIncidentIssueBulkInput!) {
    deleteIncidentIssueBulk(input: $input) {
      deleted
    }
  }
`;
